"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_FORMATS = void 0;
exports.getBaseExtension = getBaseExtension;
exports.findFileFormatKeys = findFileFormatKeys;
const file_utils_1 = require("./file-utils");
const is_valid_text_type_1 = require("./is-valid-text-type");
exports.FILE_FORMATS = {
    '3ds': { format: 'Autodesk 3DS', extensions: ['.3ds'], version: 'Any' },
    catia: { format: 'Dassault CATIA V5', extensions: ['.catpart', '.catproduct'], version: 'Up to V5-6R2025' },
    creo: { format: 'PTC Creo / Pro/ENGINEER', extensions: ['.prt', '.asm'], version: 'Pro/E 19.0 through Creo 12.4' },
    nx: {
        format: 'Siemens NX / Unigraphics',
        extensions: ['.prt'],
        version: 'UG11–UG18\nUG NX\nNX5–NX12\nNX1847–NX2506',
    },
    gltf: { format: 'glTF Binary', extensions: ['.glb'], version: '2.0' },
    inventor: { format: 'Autodesk Inventor', extensions: ['.iam', '.ipt'], version: 'Up to 2026' },
    iges: { format: 'IGES', extensions: ['.igs', '.iges'], version: '5.1, 5.2, 5.3' },
    parasolid: { format: 'Parasolid', extensions: ['.x_b', '.x_t'], version: 'Up to v38' },
    solidedge: { format: 'Siemens Solid Edge', extensions: ['.asm', '.par'], version: 'V1–V20\nST1–ST10\n2019–2025' },
    solidworks: { format: 'Dassault SolidWorks', extensions: ['.sldasm', '.sldprt'], version: '97 through 2025' },
    step: { format: 'STEP', extensions: ['.step', '.stp'], version: 'AP203 Ed1/Ed2\nAP214\nAP242 Ed1/Ed2/Ed3' },
    stl: { format: 'STL', extensions: ['.stl'], version: 'Any' },
    obj: { format: 'Wavefront OBJ', extensions: ['.obj'], version: 'Any' },
    jt: { format: 'Siemens JT', extensions: ['.jt'], version: 'Up to v10.9' },
    usd: { format: 'OpenUSD', extensions: ['.usd', '.usdz'], version: '26.8' },
    scan: {
        format: 'Point clouds / scans',
        extensions: ['.e57', '.ply', '.las', '.laz', '.copc', '.pcd', '.npy', '.npz', '.bpf'],
        version: 'Any',
    },
    images: { format: 'Images', extensions: ['.gif', '.jpeg', '.jpg', '.png'], version: 'Any' },
    documents: {
        format: 'Documents',
        extensions: [
            '.csv',
            '.docx',
            '.json',
            '.log',
            '.md',
            '.odp',
            '.ods',
            '.odt',
            '.pdf',
            '.plmxml',
            '.pptx',
            '.qif',
            '.rtf',
            '.tsv',
            '.txt',
            '.xlsx',
            '.xml',
            '.yaml',
            '.yml',
        ],
        version: 'Any',
    },
    drawings: { format: '2D drawings', extensions: is_valid_text_type_1.VALID_DRAWING_EXTENSIONS, version: 'Any' },
};
function getBaseExtension(extension) {
    const lowerCased = extension.toLowerCase();
    return (0, file_utils_1.isVersionedExtension)(lowerCased) ? `.${(0, file_utils_1.getExtensionName)(lowerCased)}` : (0, is_valid_text_type_1.dropDocumentVersionSuffix)(lowerCased);
}
function findFileFormatKeys(extension) {
    const baseExtension = getBaseExtension(extension);
    return Object.keys(exports.FILE_FORMATS).filter(key => exports.FILE_FORMATS[key].extensions.includes(baseExtension));
}
//# sourceMappingURL=file-formats.js.map